import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { NotFoundComponent } from "@pages/errors/404/not-found.component";
import { RedirectIfAuthenticatedGuard } from "@guards/redirect-if-authenticated.guard";
import { MainLayout } from "./layouts/main/main.layout";
import { AuthGuard } from "@guards/auth.guard";

const routes: Routes = [
  { path: "", redirectTo: "login", pathMatch: "full" },
  {
    path: "login",
    canActivate: [RedirectIfAuthenticatedGuard],
    loadChildren: () => import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "password",
    canActivate: [RedirectIfAuthenticatedGuard],
    loadChildren: () => import("./pages/password/password.module").then((m) => m.PasswordModule),
  },
  {
    path: "planning",
    component: MainLayout,
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/planning/planning.module").then((m) => m.PlanningModule),
  },
  {
    path: "status",
    component: MainLayout,
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/status/status.module").then((m) => m.StatusModule),
  },
  {
    path: "users",
    component: MainLayout,
    canActivate: [AuthGuard],
    loadChildren: () => import("./pages/users/users.module").then((m) => m.UsersModule),
  },
  {
    path: "invite",
    canActivate: [RedirectIfAuthenticatedGuard],
    loadChildren: () => import("./pages/invite/invite.module").then((m) => m.InviteModule),
  },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
